module.exports = __webpack_public_path__ + "static/map-a4daf6f427244a859e295203a2031405.jpg";